import '../font/country/in/style.css';
import React, { useCallback, useEffect, useState } from 'react';
import { renderRoutes } from 'react-router-config';
import Routes from './Routes';
import ToastMessage from './common/ToastMessage/ToastMessage';
import RouteLoader from './RouteLoader';
import StoreLoader from './common/StoreLoader/StoreLoader';
import config from '../config/config';
import axios from 'axios'
import { connect, useDispatch } from 'react-redux';
import { setUomData } from './actions/uom';
import { useHistory, useLocation } from 'react-router-dom';
import ToastRedux from 'jd-library/ToastRedux';
import { setSession, setContractData, setLoggedUser, setIsUserApprovedForCatCoverage} from './actions/index';
import { prepareApiUrls } from './common/productImageUtils';
import { setAllPermissions } from './actions/permissions';
import { getVideoLibraryData } from './actions/videoLibrary';
import BeforeUnloadHandler from './BeforeUnloadHandler';
import AddEditProduct from './pages/add-edit-product/AddEditProduct';
import AddEditProductOmni from './pages/omni-add-edit-product/AddEditProductOmni';
import EnrichEditProduct from './pages/enrich-product/EnrichEditProduct';
import ItemSearchSlider from './pages/add-edit-product/ItemSearchSlider';
import IconCSS from './common/IconCSSLoadable';
import PhotoSlider from './pages/photo-slider/PhotoSlider';
import { togglePhotoSlider } from './actions/photosGallery';
import { checkForCameraPermissions, getJdMartParams, checkLoggedIn, getParameterByName, getQueryParam, identifyAuditFlow, setCurrentDeviceDetails, setJdMartParams, getPlatform, customUrlHandler, checkAutoLogin, checkNFilterMultipleSlashes, getCookie} from './utills';
import BarcodeScanner from '../client/pages/add-edit-product/scanner/BarcodeScanner';
import UploadOptions from './common/upload-options/UploadOptions';
import LinkUploadSlider from './common/link-upload-slider/LinkUploadSlider';
import NotFoundModal from './common/NoResultFound/NotFoundModal';
import ModalWithSingleBtn from './pages/add-edit-product/c-specification-slider/components/ModalWithSingleBtn/ModalWithSingleBtn';
import './App.scss'
import AddPriceCard from './pages/listing/AddPriceCard';
import FeedbackSlider from './common/Feature/FeedbackSlider';
import CropperPortal from './common/ImageCropper/CropperPortal';
import { actionCardFilter, clickTrack, getListingData, setPauseApprovalRedirect, setTabStatus, setVendorImages, toggleActionCardSlider,fetchPsvInfo } from './actions/products';
import WalkThrough from './common/Walkthrough/WalkThrough';
import OutDatedPriceCard from './common/Feature/OutDatedPriceCard';
import CategoryMissing from './common/Feature/CategoryMissing';
import SupportSlider from './common/SupportSlider/SupportSlider';
import AISucessModal from './common/AISuccessModal';
import BrochureUploadModal from './pages/listing/BrochureUploadModal';

const getUom = async () => {
	// return {};
	let cachedUOM = {};
	const uomResult = await axios.get(config.apiDomains[0] + '/marketplace/vendorProduct/getUomJson.ns?uomFor=productuom,netweight,serviceuom');
	if (!uomResult.data.isError) {
		cachedUOM = uomResult.data.data;
	}
	else {
		return {};
	}
	let uomJsonMap = {};
	let uomJson = Object.assign({}, cachedUOM.netweight, cachedUOM.productuom, cachedUOM.serviceuom);

	uomJson.other.map(item => {
		uomJsonMap[item['val']] = item;
	});
	uomJson.popular.map(item => {
		uomJsonMap[item['val']] = item;
	});
	return {
		uomJsonMap,
		productUOM: [...cachedUOM.productuom.popular, ...cachedUOM.productuom.other],
		netweightUOM: [...cachedUOM.netweight.popular, ...cachedUOM.netweight.other],
		serviceUOM: [...cachedUOM.serviceuom.popular, ...cachedUOM.serviceuom.other],
	};
}

axios.interceptors.request.use(function (config) {
	if (typeof window == "undefined") {
		return config;
	}
	const source = Number(encodeURIComponent(getParameterByName('source')));
	let url = config.url;
	  const JDBusiness = [1, 21, 51, 3, 23, 53].indexOf(source) != -1;
	  if (JDBusiness && /(getCompanyDetails|\.ns)/ig.test(url)) {
	  const sid = encodeURIComponent(getParameterByName('sid'));
	  config.params = {...config.params, "sid": sid}
	  }
	  return config;
	}, function (error) {
	  // Do something with request error
	  return Promise.reject(error);
});

let blockedPaths = [
	'/products/inventory',
	'/products/inventory/low-inventory',
	'/products/inventory/out-of-stock',
	'/orders',
	'/orders/active-orders',
	'/orders/confirmation-pending',
	'/orders/dispatch-delivery',
	'/orders/delivery-pickup-pending',
	'/orders/delivery-pending',
	'/orders/archived',
	'/orders/return',
	'/deliveryboy',
	'/deliverycharge',
	'/orders/return',
	'/orders/return/return-inventory',
	'orders/return/return-completed',
	'/products/discount/add',
	'/products/discount',
	'/orders-new'
]


const checkAccessForCatCoverage = ({mobile, empid, docid, token, obe, contractor}, cb) => {
    const payload = {docid, token, obe, contractor}
    axios.post(`/marketplace/dc-common/getAccessForCatCoverage.ns`, payload, {
        headers: {
            'mobileno': mobile,
            'empid': empid
        }
    }).then((rsp) => {
      if(rsp.data?.error==0) {
        cb(rsp.data?.results);
      }  else {
        cb(false);
      } 
    }).catch(err => {
        console.log(err);
        cb(false);
    })   
}


const App = props => {
	if (typeof window !== 'undefined') {
		const querysource = getQueryParam("source");
		const isSd = getQueryParam("sd")
		if (!querysource && isSd) {
			const urlParams = new URLSearchParams(window.location.search);
			urlParams.set("source", 52);
			window.location.search = urlParams;
		}
	}
	function replaceAllcustom(str, replace){
		return  this.replace(new RegExp(str, 'g'),replace)
	}
	if(!String.prototype?.replaceAll){
		String.prototype.replaceAll = replaceAllcustom
	}
	const history = useHistory();
	const location = useLocation();
	const dispatch = useDispatch();
	let isJdApp = false;
	const [missingDataModal,toggleMissingModal] = useState(false);
	const [showWalkthrough,toggleWalkthrough] = useState(false);
	const [apiChecked,updateApiChecked] = useState(false);
	const [expiryHTM,updateHTML] = useState(null);
	const [smartCardData, setSmartCardData] = useState({ filterStr: "", cardName: "", path: "", count: "" })
	const isObeFromSSO = props.session.user?.loggedUser?.subType == "OBE";
	let selectTypeQuery = identifyAuditFlow({ query: true });
	const [gotSource] = useState(selectTypeQuery.source || '');
	const getContractDetails = (notGenioUrl = false,redirectedFromJD = '') => {
		let url = `/vendor/manage-products-genio/${props.session.token}/api/getContractData.ns?redirectedFromJD=${redirectedFromJD}&omni=${window.session?.viaOmni}`;
		let customHeaders = {
			'token': window.session?.viaOmni ? sessionStorage.getItem('authToken') : ''
		}
		axios.post(url,null,{headers:customHeaders}).then((data) => {
			if (data.data.isSuccess) {
				let sessionData = data.data.prodCrudData;
				if(isJdApp && !notGenioUrl){
					sessionData.loggedUser = {userType: 'OWNER'};
					getOwnerType({
						cb: (data) => {
							if(data.isJdRep) {
								props.setLoggedUser({
									userType: 'JDEMPLOYEE'
								})
							}
						}
					});
				}
				sessionData.reduxSessionInit = true;
				props.setContractData(sessionData);
				data.data.backUrl && props.setSession({backUrl: data.data.backUrl});
			} else if (location.pathname != '/products' && data.data.errorCode == 1) {
				history.push("/products");
			}else if(!data.data.isSuccess && data.data.isExpiry) {
				let htm = `<h1>Your login session has expired.</h1>`;
				if(data.data.isOmni) {
					setTimeout(function(){
						window.location.assign(window.location.origin + '/myaccount');
					},1000)
				}
			}
		});
		window.onfocus = getContractDetails;
	};
	const getOwnerType = (options = {}) => {
		const {cb} = options;
		const url = `/marketplace/static/php/web/checkJdUserType.php?token=${encodeURIComponent(props.session.token)}`;
		axios.get(url).then((data) => {
			if(data.data.isSuccess) {
				cb && cb(data.data)
			}
		});
	};

	const checkForWalkthrough = (session) => {
		let docid = session.docId;
		axios.get('/marketplace/omni-db-api/ajax/getWalkThroughFlag?docId='+docid).then(res => {
			if(res.data.status && !res.data.results.flag) {
				toggleWalkthrough(true);
			}
		}).catch(err => {
			console.log('walkthrough Err: ',err);
		})
	}

	useEffect(() => {
		if (props.session.user?.obeData?.mobile_num || gotSource) {
			getContractDetails(false,gotSource);
		}
	}, [props.session.user.obeData,gotSource])
	
	useEffect(() => {
		if(!props.session.viaOmni && props.isMobile && props.session?.docId && props.session?.user?.loggedUser?.userType == 'OWNER' && !apiChecked) {
			checkForWalkthrough(props.session)
			updateApiChecked(true);
		}
	},[props.session])

	useEffect(async () => {
		console.log("app is mounted")
		async function loadDcApp() {
			if (-1!==window.location.href.indexOf('//', 8)) {
				let newURL = checkNFilterMultipleSlashes(window.location.href);
				if (newURL) {
					window.location.replace(newURL);
				} else {
					history.push("/products");
				}
			}
			const fromAutoLogin = await checkAutoLogin(props?.session?.token, props?.session?.user?.loggedUser?.userType);
				setJdMartParams();
			checkForCameraPermissions();
			if(window.location.href.indexOf('/products') != -1 && window.location.href.indexOf('dcback=1') != -1 && (getCookie("appVersion") >= '14.2' || getQueryParam('version') >= '14.2') && props.isJdSourceIOS) {
				setTimeout(() => {
					if(!window.gotData) {
						let params = new URLSearchParams(location.search);
						params.delete('dcback');
						window.history.replaceState({},'',window.location.origin+'/products?'+params+location.hash)
						history.replace('/products?' + params + location.hash);
						window.location.reload();					
					}
				}, 3000);
			}
			isJdApp = window.location.href.indexOf('manage-products/') != -1;
			// if (props.session.source == 'webstore') {
			// 	ProductIframeCommunication.initialize({
			// 		domainName: window.location.protocol + '//' + window.location.host,
			// 		pageType: "add",
			// 		token: 'rememberMe',
			// 		delay: Infinity
			// 	});
			// 	props.setAllPermissions();
			// }
			getUom().then(result => {
				props.setUomData(result);
				props.setSession({
					isAppInitialized: true
				});
			});
			if (props.session.source == 'webstore') {
				axios.get("/omni_ns/getCompanyDetails")
					.then(({ data }) => {
						if (data.isSuccess) {
							prepareApiUrls({
								source: 'webstore',
								supplierId: data.supplierId
							})
							props.setSession({
								companyName: data.companyName,
								supplierId: data.supplierId,
								domainName: data.domainName,
								baseUrl: data.baseUrl
							})
						}
					})
			} else {
				let source = identifyAuditFlow({query : true}).source;
				let subsource = identifyAuditFlow({query : true}).subsource;
				let JDBus_ep = identifyAuditFlow({query : true}).ep;
				let rootVc = identifyAuditFlow({query : true}).rootvc;
				let fromGenioLite = getCookie('fromGenioLite');
				if(Array.isArray(source)) {
					source =  source[0]?.split(',')[0];
				}else {
					source = source?.split(',')[0];
				}
				if (JDBus_ep) {
					props.setSession({
						JDBus_ep : JDBus_ep
					})
				}
				if (rootVc){
					props.setSession({
						rootVc : rootVc
					})
				}
				let isReadOnly = ((window.location.search && window.location.search.indexOf('isReadOnly=1') != -1) || (getCookie("ublcs")==1));				
				let searchParams = window.location.search || '';
				const contractorTypes = ["CONTRACTOR", "CONTRACTORV2", "CONTRACTORV3", "CONTRACTORV4"];
				const isAuditUrl = !!(identifyAuditFlow({checkType: true})?.fetchNextAudit);
				const isAuditor = props?.session?.user?.loggedUser && props?.session?.user?.loggedUser?.userType == "AUDITOR" && isAuditUrl ? true : false;
				const isAuditEnrichProductUrl = (isAuditUrl && isAuditor && window.location.pathname.search('/products/editEnrich/')) ||
											(isAuditor && window.location.pathname.search('/audit-enrich-home')) ||
											window.location.pathname.search('/audit-enrich-login');
				const isContractor = props?.session?.user?.loggedUser && (contractorTypes.indexOf(props?.session?.user?.loggedUser?.subType) != -1)
				let apiUrl = '/marketplace/static/php/web/b2bWebsite.php?&action=getCompanyDetails&token=' + props.session.token+'&platform='+getPlatform()+'&dcPfm='+getJdMartParams().sourceId+'&fromAutoLogin='+fromAutoLogin;
				await setCurrentDeviceDetails(props.session.token);
				console.log("after setCurrentDeviceDetails");
				console.log("cookie after setCurrentDeviceDetails",document.cookie);
				const urlParameters = identifyAuditFlow({query: true});
				const closeIframe = urlParameters.closeIframe == '1';
				let {msg_templt = '',comm_chanel = '',evnt_dt = '',cust_segmnt = '',campaign_name = '',data_source = ''} = urlParameters;
				apiUrl += `&msg_templt=${msg_templt}&comm_chanel=${comm_chanel}&evnt_dt=${evnt_dt}&cust_segmnt=${cust_segmnt}&campaign_name=${campaign_name}&data_source=${data_source}`;
				let showCompanyDetails  = props.session.showCompanyDetails;
				let companyData = '';
				await axios.get(apiUrl).then(result => {
					let companyDetails = {};
					if(result.data.status) {
						companyDetails = result.data.data.companyDetails;
						prepareApiUrls({
							supplierId: companyDetails.supid
						})
						if(companyDetails.supid && props.session.token) {
							let payload = {
								supId : companyDetails.supid,
								token : props.session.token,
								viaOmni:companyDetails.tokenType == 'omni',
							}
							props.setAllPermissions(payload);
						}
						showCompanyDetails = ['genio','jdexecutive','owner','omni'].includes(companyDetails.tokenType) || props.session.showCompanyDetails;
						if(companyDetails.tokenType == 'omni'){
							companyDetails.newProfile=2
						}
						const appVersion = getQueryParam('version') || getCookie("appVersion");
						let sessionObj = {
							companyName: companyDetails.cname,
							city: companyDetails.city,
							state: companyDetails.state,
							state_id: companyDetails.stateId,
							docId: companyDetails.docid,
							countryCode: companyDetails.countryCode || 'IN',
							supplierId: companyDetails.supid,
							videoExists: companyDetails.videoExists,
							isReadOnly: isReadOnly,
							newProfile: companyDetails.newProfile,
							profileObject: {
								isRE:[0,2,4].includes(Number(companyDetails.newProfile)),
								isSO:[1,2].includes(Number(companyDetails.newProfile)),
								isSer:[2,3,4].includes(Number(companyDetails.newProfile)),
								SingleLabel: companyDetails.newProfile == 3 ? "Service" : ([2,4].includes(Number(companyDetails.newProfile))) ? "Product/Service" : "Product",
								SingleLabelWithSpace: companyDetails.newProfile == 3 ? "Service" : ([2,4].includes(Number(companyDetails.newProfile))) ? "Product / Service" : "Product",
								PluralLabel:companyDetails.newProfile == 3 ? "Services" : ([2,4].includes(Number(companyDetails.newProfile))) ? "Products/Services" : "Products",
								PluralLabelWithSpace:companyDetails.newProfile == 3 ? "Services" : ([2,4].includes(Number(companyDetails.newProfile))) ? "Products / Services" : "Products",
							},
							bulkUploadProfile : [2,3,4].includes(Number(companyDetails.newProfile)) ? 1 : 0,
							img_required_flag: companyDetails.img_required_flag,
							businessType: companyDetails.businessType,
							userSource: source,
							subSource: subsource,
							searchParams: searchParams,
							isOnboardingEmp: companyDetails.isOnboardingEmp,
							jdmart_tag: companyDetails.jdmart_tag,
							verticalId: companyDetails.verticalId,
							verticalGroup: companyDetails.verticalGroup,
							brochureButton: companyDetails.brochureButton,
							platformDC: companyDetails.platformDC,
							viaOmni: companyDetails.tokenType == 'omni',
							backUrl:new URLSearchParams(window.location.search).get("backurl"),
							appVersion,
							closeIframe,
							showAIImages: companyDetails.showAIImages,
							showCompanyDetails,
							isPaid: companyDetails.isPaid,
							isShopVirtual: companyDetails.isShopVirtual,
							hideSuggestedAutoServiceSlider : companyDetails?.sugg_service_flag,
							hasGlassFooter: props.isJdBusinessIOS && parseFloat(appVersion) >= 3.3,
							fromGenioLite: fromGenioLite == '1' ? true : false
						};
						
						if(selectTypeQuery?.closeIframe == '1'){
							if (companyDetails?.sugg_service_flag  && selectTypeQuery?.selectedProductType == 'service'){
							  window.location.href.replace('/products/itemsearch','/products/add-omni');  
							}
						}
						if (selectTypeQuery?.closeIframe == "1") {
							setTimeout(() => {
								props.fetchPsvInfo();
							}, 500);
						}
						let backUrl = new URLSearchParams(window.location.search).get("backurl") || '';
						if(backUrl) {
							sessionObj['backUrl'] = backUrl;
						}
						if (isObeFromSSO)
						{
							if(fromGenioLite == '1') {
								dispatch(setIsUserApprovedForCatCoverage(true));
							} else {
								checkAccessForCatCoverage({
									mobile: props?.session?.user?.loggedUser?.userName,
									empid: isObeFromSSO ? props?.session?.user?.loggedUser?.rId : '',
									docid: companyDetails.docid,
									token: props?.session?.token,
									obe: isObeFromSSO ? true : false,
									contractor: props?.session?.user?.loggedUser?.subType == "CONTRACTOR" ? 'v1' : null
								}, (result) => {
									if (result == true){
										dispatch(setIsUserApprovedForCatCoverage(true));
									}
								});
							}
						}
						if(companyDetails.tokenType == 'omni') {
							window.session = sessionObj;
						}
						props.setSession(sessionObj);
						if(closeIframe) {
							document.body.style.background = 'transparent';
							document.body.className = 'closeIframe';
						}
						if(companyDetails.tokenType != 'omni') {
							setTimeout(() => {
								props.clickTrack({li: 'dc_landing', ll: 'digital_catalog',userBasedCheck: true});
							}, 500);
						}
						if(showCompanyDetails && isJdApp) {
							getContractDetails(true,companyData);
						}
						if(blockedPaths.includes(location.pathname)) {
							let discount = location.pathname.includes('discount');
							let orderListing = location.pathname.includes('order');
							let inventory = location.pathname.includes('inventory')
							checkLoggedIn({
								history,
								discount,
								orderListing,
								inventory,
								isJdMartToken: companyDetails.jdmart_tag,
							})
						}	
					}else if(!result.data.status && result.data.msg === "Unable to create contract"){
						if (!isAuditEnrichProductUrl) {
							toggleMissingModal(true);
						}
						if (!isAuditor && !isContractor) {
							const debugDtls = {
								url : apiUrl,
								res : result,
								sid: getCookie("sid"),
								from: "backend"
							}
							// errorEmail({
							// 	message: result.data.msg,
							// 	stack: result.data.msg
							// }, debugDtls);
						}
						return;
					}else{
						// if(!result.data.status && result.data.msg == 'Not Authorised') {
						// 	props.setSession({
						// 		...props.session,
						// 		notAuthorised: true
						// 	})				
						// }
						if(window.location.pathname.indexOf('discount') !== -1){
							history.replace('/products');
						}						
					}
					if(isJdApp && (showCompanyDetails ? !props.session.user.loggedUser : true)){
						let loggedUser = (companyDetails.jdmart_tag && blockedPaths.includes(location.pathname)) || showCompanyDetails ? '' : {userType: 'OWNER'};
						props.setLoggedUser(loggedUser)
						getOwnerType({
							cb: (data) => {
								if(data.isJdRep) {
									props.setLoggedUser({
										userType: 'JDEMPLOYEE'
									})
								}
							}
						});
					}
				})
				props.getVideoLibraryData();
				if (props.session.showCompanyDetails || props.session.jdmart_tag) {
					getContractDetails(false,companyData);
				}
			}
			return () => {
				setJdMartParams(true);
			};	
		}
		loadDcApp();
	}, [])
	useEffect(() => {
		const allowedRoutes = [
			"/products/smartcard/priceMissingCount",
			"/products/smartcard/smartPriceMissingCount",
			"/products/smartcard/imgMissingCoun",
			"/products/smartcard/specMissingCount",
			"/products/smartcard/descMissingCount",
			"/products/smartcard/rejectedCount",
			"/products/smartcard/nonexistingjdmartidcount",
		]
		const showAddPriceTag = props.showAddPriceTag;
		const showOutDatedPriceTag = props.showOutDatedPriceTag
		const showCategoryMissingCard = props.showCategoryMissingCard
		const { loggedUser } = props?.session?.user || {}
		const isLoggedIn = loggedUser;
		if (allowedRoutes.includes(location?.pathname)) {
			const cardDetails = getCardDetails(location?.pathname)
			dispatch(setPauseApprovalRedirect(true))
			if(cardDetails.status){
				setSmartCardData({ cardName: cardDetails.cardName, filterStr: cardDetails.filterStr, path: `/${location?.pathname.split("/").slice(2).join("/")}`, count: "" })
			}else{
				props?.session?.supplierId ? customUrlHandler(isLoggedIn, location?.pathname, props?.session?.supplierId, history, showAddPriceTag, showOutDatedPriceTag, showCategoryMissingCard) : null
			}
		}
		if(smartCardData.cardName && Object.keys(props?.getNotificationData).length){
			setSmartCardData(prv => ({ ...prv, count: getCardDataCount(location?.pathname, props.getNotificationData) || 0 }))
		}
		if(location.pathname.includes("brochure")){
			dispatch(setTabStatus({ tabKey: "brochure" }))
		}
	}, [location?.pathname, props?.session?.supplierId,props?.getNotificationData])

	const getCardDetails = (path) => {
		const isProductOnlyProfile = props.session.newProfile
		const profileType = isProductOnlyProfile == 3 ? "Services" : isProductOnlyProfile == 2 ? "Products/Services" : "Products";
		const rspObj = { status: true, cardName: "", filterStr: "" }
		if (path.includes("/smartcard/imgMissingCoun")) {
			rspObj.cardName = "Add Image"
			rspObj.filterStr = "&imagePresent=no"
		} else if (path.includes("/smartcard/specMissingCount")) {
			rspObj.cardName = "Add Specification"
			rspObj.filterStr = "&specPresent=no"
		} else if (path.includes("/smartcard/descMissingCount")) {
			rspObj.cardName = "Add Description"
			rspObj.filterStr = "&descPresent=no"
		} else if (path.includes("/smartcard/rejectedCount")) {
			rspObj.cardName = `Rejected ${profileType}`
			rspObj.filterStr = "&tab=rejected"
		} else {
			rspObj.status = false
		}
		return rspObj
	}

	const getCardDataCount = (path,data) => {
		let count = 0
		if (path.includes("/smartcard/imgMissingCoun")) {
			count = data.imgMissingCount || "0"
		} else if (path.includes("/smartcard/specMissingCount")) {
			count = data.specMissingCount || "0"
		} else if (path.includes("/smartcard/descMissingCount")) {
			count = data.descMissingCount || "0"
		} else if (path.includes("/smartcard/rejectedCount")) {
			count = data.rejectedCount || "0"
		}
		return count
	}

	useEffect(() => {
		// here compare string 0 for even if count not found then also open slider to show no product but number 0 means still api not call so allowed unwanted render
		if(smartCardData.cardName && (smartCardData.count || smartCardData.count == "0") && props?.session?.supplierId && location?.pathname.includes("/smartcard")){
			const locationArr = location?.pathname.split("/")
			dispatch(actionCardFilter({ cardName: smartCardData.cardName, filterQuery: smartCardData.filterStr, type: locationArr[locationArr.length - 1] }))
			dispatch(getListingData({
				isFilter: true,
				filterStr: smartCardData.filterStr,
				cardName: smartCardData.cardName,
				count: smartCardData.count,
				cb: (data) => {
					history.push("/products")
					// this delay required for change route and then control goes to listingheader bcoz are actionslider is on listingheader
					setTimeout(() => {
						dispatch(toggleActionCardSlider({isActionCardSliderOpen: true}))
					}, 300);
					setSmartCardData({ filterStr: "", cardName: "", path: "", count: "" })
					if(props.isMobile){
						let url = `/${location?.pathname.split("/").slice(2).join("/")}`;
						history.push(url);
					}
				}
			}))
		}
	}, [smartCardData])
	const countryCode = (props.session.countryCode || "IN").toLowerCase();
	//TODO: remove common toastmessage use only of library
	const NoResultModal = useCallback(() => {
		return <NotFoundModal barcode={props.barcode} closeCB={props.closeCB} />
	},[props.showNotFoundModal])

	const missingModalData = {
		infoText: `Please ensure that <b>mobile number</b> and <b>pincode</b> are updated against this contract`,
		btnText: "Okay, Got it",
		onHidden: () => toggleMissingModal(false),
		btnClick: () => window.history.go(-2)
	}
	if(expiryHTM) {
		return (<div className={'expiry'} dangerouslySetInnerHTML={{__html: expiryHTM}} />);
	}

	let FilteredRoutes=Routes

	if(props.session?.companyName==undefined){
		FilteredRoutes=Routes.filter(route=>!route.requireSession)
	}

	return (
		<div className={props.session.isReadOnly ? "read-only-view" : ""}>
			<RouteLoader>{renderRoutes(FilteredRoutes)}</RouteLoader>
			<div id="react-slider-holder" className={props.isMobile? 'wap' : 'desktop'}></div>
			<div id='portal-root'></div>
			<ToastRedux />
			<ToastMessage />
			<StoreLoader />
			<BeforeUnloadHandler />
			{countryCode != 'in' ? <IconCSS
				pageName={"country/"+countryCode}
			/> : null}
			{props.session?.companyName!=undefined && props.showAddEditProduct && !props.isMobile && !props.session.viaOmni && (
				<AddEditProduct />
			)}
			{props.session?.companyName!=undefined && props.showAddEditProductOmni && !props.isMobile && (
				<AddEditProductOmni />
			)}
			{props.session?.companyName!=undefined && props.showEnrichEditProduct && !props.isMobile ?
				<EnrichEditProduct />
			: null}
			{props.showItemSearch && !props.isMobile && (
				<ItemSearchSlider />
			)}
			{props.fromSellerDashboard && !props.isMobile ? <> <UploadOptions/> <LinkUploadSlider /> </> : null}
			{props.selectPhotoSlider ? <PhotoSlider onHidden={()=>{props.togglePhotoSlider({selectPhotoSlider: false});props.setVendorImages([],true)}} productId={props.productId} /> : null}
			{(props.isMobile && props.showScannerSecond ? <BarcodeScanner />: null)}
			{props.showNotFoundModal ? <NoResultModal /> :null}
			{missingDataModal ? <ModalWithSingleBtn {...missingModalData} />: null}
			{props.showAddPriceTag ? <AddPriceCard session={props.session} /> : null}
			{props.showOutDatedPriceTag ? <OutDatedPriceCard session={props.session} /> : null}
			{props.showFeedbackForm ? <FeedbackSlider /> : null}
			{ props.showEditOptions ? <CropperPortal /> : null	}
			{showWalkthrough ? <WalkThrough hideWalkthrough={() => {props.setSession({...props.session,isFirstTime: false});toggleWalkthrough(false)}} /> : null}
			{props.showCategoryMissingCard ? <CategoryMissing /> : null}
			{props.showSupportSlider ? <SupportSlider /> : null}
			{props.showAICreationModal?.successModal?.show ? <AISucessModal /> : null}
			{props.showAICreationModal?.brochureUploadModal?.show ? <BrochureUploadModal uploadedFiles={props.showAICreationModal?.brochureUploadModal?.uploadedFiles} /> : null}
		</div>
	)
	
};

const mapStateToProps = state => {
	return {
		session: state.session,
		isMobile:state.library.deviceData.isMobile,
		showAddEditProduct:state.products.showAddEditProduct,
		showAddEditProductOmni:state.products.showAddEditProductOmni,
		showEnrichEditProduct: state.products.showEnrichEditProduct,
		showNotFoundModal: state.products.showNotFoundModal,
		barcode: state.products.barcode,
		closeCB: state.products.closeCB,
		showItemSearch: state.products.showItemSearch,
		selectPhotoSlider: state.photosGallery.selectPhotoSlider,
		productId: state.photosGallery.productId,
		showReduxToast: state.library.toastMessage.showReduxToast,
		isVariant: state.photosGallery.isVariant,
		showScannerSecond: state.barcodeScanner.showScannerSecond,
		fromSellerDashboard: state.products.fromSellerDashboard,
		isJdSourceIOS: state.session.isJdSourceIOS,
		showAddPriceTag: state.products.showAddPriceTag,
		showFeedbackForm: state.feedback.showFeedbackForm,
		showEditOptions: state.products.showEditOptions,
		pendingTabs: state.products.pendingTabs,
		showOutDatedPriceTag: state.products.showOutDatedPriceTag,
		showCategoryMissingCard: state.products.showCategoryMissingCard,
		getNotificationData: state?.notifications?.counts,
		showSupportSlider: state?.products?.showSupportSlider,
		isJdBusinessIOS: state.session.isJdBusinessIOS,
		showAICreationModal: state.products.showAICreationModal
	};
};

export default connect(mapStateToProps, {
	setUomData,
	setSession,
	getVideoLibraryData,
	setContractData,
	setAllPermissions,
	togglePhotoSlider,
	setVendorImages,
	setLoggedUser,
	clickTrack,
	fetchPsvInfo
})(App);
